import { motion } from 'framer-motion';
import Navbar from '@/components/Navbar';
import Footer from '@/components/Footer';

export default function TermsOfService() {
  return (
    <div className="min-h-screen bg-white">
      <Navbar />
      <section className="pt-24 pb-16">
        <div className="max-w-3xl mx-auto px-4 sm:px-6 lg:px-8">
          <motion.div initial={{ opacity: 0, y: 20 }} animate={{ opacity: 1, y: 0 }}>
            <h1 className="text-4xl font-bold text-slate-900 mb-8" data-testid="terms-title">Terms of Service</h1>
            <p className="text-sm text-slate-500 mb-8">Last updated: March 2026</p>

            <div className="prose prose-slate max-w-none space-y-6 text-slate-600 leading-relaxed">
              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">1. Acceptance of Terms</h2>
                <p>By accessing and using AirVia (airviaindia.com), you agree to be bound by these Terms of Service. If you do not agree to these terms, please do not use our services.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">2. Service Description</h2>
                <p>AirVia provides customized flight subscription plans for domestic travel within India. Users submit their travel requirements through our interest form, and our team creates personalized subscription plans with flat-rate pricing.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">3. Subscription Plans</h2>
                <p>Subscription plans are customized based on your travel route, ticket requirements, and frequency. Pricing and terms will be communicated to you within 24 hours of submitting your interest form. Plans are subject to availability and airline partnerships.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">4. Pricing</h2>
                <p>All prices displayed on our website are indicative and may vary based on your specific requirements. Final pricing will be confirmed in your personalized subscription plan. Prices are in Indian Rupees (INR) and inclusive of applicable taxes unless stated otherwise.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">5. Cancellation & Refund</h2>
                <p>Cancellation and refund policies are specific to each subscription plan and will be clearly mentioned in your personalized agreement. Please review these carefully before confirming your subscription.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">6. User Responsibilities</h2>
                <p>You agree to provide accurate personal and travel information. You are responsible for maintaining the confidentiality of your account credentials. Any bookings made through your account are your responsibility.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">7. Limitation of Liability</h2>
                <p>AirVia acts as an intermediary between you and airline partners. We are not liable for flight delays, cancellations, or changes made by airlines. We will, however, assist you in rebooking or getting refunds as per airline policies.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">8. Changes to Terms</h2>
                <p>We reserve the right to update these terms at any time. Changes will be posted on this page with an updated date. Continued use of our services after changes constitutes acceptance of the new terms.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">9. Governing Law</h2>
                <p>These terms are governed by the laws of India. Any disputes shall be subject to the exclusive jurisdiction of courts in Bengaluru, Karnataka.</p>
              </section>

              <section>
                <h2 className="text-xl font-bold text-slate-900 mb-3">10. Contact</h2>
                <p>For questions about these terms, contact us at:</p>
                <p>Email: hello@airviaindia.com</p>
                <p>Address: OXFORD TOWER, 139/88 HAL OLD AIRPORT RD, H.A.L II Stage, Bengaluru 560008</p>
              </section>
            </div>
          </motion.div>
        </div>
      </section>
      <Footer />
    </div>
  );
}
